import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 菜单类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class MenuService extends ServiceBase
{
    /**
     * 菜单切换
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async menuChange(appId: number): Promise<IHttpResponse>
    {
        let response = await this.apis.menuChange({
            params: { appId }
        });

        return response;
    }

    /**
     * 获取系统菜单树，用于给角色授权时选择
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async treeForGrant(appId?: number): Promise<IHttpResponse>
    {
        let response = await this.apis.treeForGrant({
            params: { appId }
        });

        return response;
    }

    /**
     * 系统菜单列表（树表）
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getMenuList(): Promise<IHttpResponse>
    {
        let response = await this.apis.getMenuList({});

        return response;
    }

    /**
     * 新增/编辑菜单
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async opertionMenu(data: any): Promise<IHttpResponse>
    {
        let response;
        if(data.id)
        {
            response = await this.apis.editMenu({data});
        }
        else
        {
            response = await this.apis.addMenu({data});
        }

        return response;
    }

    /**
     * 编辑菜单
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async editMenu(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.editMenu({data});

        return response;
    }

    /**
     * 删除菜单
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async delMenu(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.delMenu({urlPath:{id}});

        return response;
    }
}